export default {
  id: 'email_gamification_individual',
  title: 'Gamification Individual',
  type: 'Direct',
  subject: 'Leaderboard & Collective Goal Standings',
  description: 'Current status of the leaderboard and collective goal including the current user\'s position.',
  mjml: `<mjml>
  <mj-body>
    <mj-section>
      <mj-column>

        <mj-image src="[[INPUT_BANNER_IMAGE]]"></mj-image>

        <mj-text font-size="14px" line-height="1.5" font-family="helvetica">[[INPUT_INTRODUCTION_TEXT]]</mj-text>
        
        <mj-divider></mj-divider>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column width="80%">
        <mj-table padding="0" padding-bottom="10px">
          <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥇</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥈</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥉</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">...</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">{{LEADERBOARD_POSITION}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{FIRST_NAME}} {{LAST_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POINTS}} points</td>
    </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column>
        
        <mj-divider></mj-divider>

        <mj-text font-size="14px" line-height="1.5" font-family="helvetica">[[INPUT_END_TEXT]]</mj-text>

      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  body: `<!doctype html>
  <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  
  <head>
    <title>
    </title>
    <!--[if !mso]><!-->
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <!--<![endif]-->
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style type="text/css">
      #outlook a {
        padding: 0;
      }
  
      body {
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }
  
      table,
      td {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt;
      }
  
      img {
        border: 0;
        height: auto;
        line-height: 100%;
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic;
      }
  
      p {
        display: block;
        margin: 13px 0;
      }
    </style>
    <!--[if mso]>
          <noscript>
          <xml>
          <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
          </o:OfficeDocumentSettings>
          </xml>
          </noscript>
          <![endif]-->
    <!--[if lte mso 11]>
          <style type="text/css">
            .mj-outlook-group-fix { width:100% !important; }
          </style>
          <![endif]-->
    <!--[if !mso]><!-->
    <link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css">
    <style type="text/css">
      @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);
    </style>
    <!--<![endif]-->
    <style type="text/css">
      @media only screen and (min-width:480px) {
        .mj-column-per-100 {
          width: 100% !important;
          max-width: 100%;
        }
  
        .mj-column-per-80 {
          width: 80% !important;
          max-width: 80%;
        }
      }
    </style>
    <style media="screen and (min-width:480px)">
      .moz-text-html .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
  
      .moz-text-html .mj-column-per-80 {
        width: 80% !important;
        max-width: 80%;
      }
    </style>
    <style type="text/css">
      @media only screen and (max-width:480px) {
        table.mj-full-width-mobile {
          width: 100% !important;
        }
  
        td.mj-full-width-mobile {
          width: auto !important;
        }
      }
    </style>
  </head>
  
  <body style="word-spacing:normal;">
    <div style="">
      <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                            <tbody>
                              <tr>
                                <td style="width:550px;">
                                  <img height="auto" src="[[INPUT_BANNER_IMAGE]]" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="550" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <div style="font-family:helvetica;font-size:14px;line-height:1.5;text-align:left;color:#000000;">[[INPUT_INTRODUCTION_TEXT]]</div>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <p style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:100%;">
                          </p>
                          <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
  </td></tr></table><![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:480px;" ><![endif]-->
                <div class="mj-column-per-80 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="left" style="font-size:0px;padding:0;padding-bottom:10px;word-break:break-word;">
                          <table cellpadding="0" cellspacing="0" width="100%" border="0" style="color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;table-layout:auto;width:100%;border:none;">
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥇</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥈</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥉</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">...</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">{{LEADERBOARD_POSITION}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{FIRST_NAME}} {{LAST_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POINTS}} points</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:480px;" ><![endif]-->
                <div class="mj-column-per-80 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="left" style="font-size:0px;padding:0;padding-bottom:10px;word-break:break-word;">
                          <table cellpadding="0" cellspacing="0" width="100%" border="0" style="color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;table-layout:auto;width:100%;border:none;">
                            <tr>
                              <td style="font-size: 16px; padding-bottom: 10px">
                                {{COLLECTIVE_GOAL_ICON}} <strong>{{COLLECTIVE_GOAL_HEADLINE}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td><strong>{{COLLECTIVE_GOAL_PROGRESS}} {{COLLECTIVE_GOAL_FIRST_LINE}}</strong> {{COLLECTIVE_GOAL_SECOND_LINE}}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <table style="border:0; border-radius: 5px; overflow: hidden" cellpadding="0" cellspacing="0" width="100%">
                        <tr style="padding:10px 25px">
                          <td bgcolor="#007bff" style="width:{{COLLECTIVE_GOAL_PERCENTAGE}}%; background-color:#007bff; float:left; height:15px;"></td>
                          <td bgcolor="#cccccc" style="width:{{COLLECTIVE_GOAL_PERCENTAGE_REMINDER}}%; background-color:#cccccc; float:left; height:15px;"></td>
                        </tr>
                      </table>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <p style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:100%;">
                          </p>
                          <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
  </td></tr></table><![endif]-->
                        </td>
                      </tr>
                      <tr>
                        <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                            <tr>
                              <td align="center" bgcolor="#1d52ce" role="presentation" style="border:none;border-radius:3px;cursor:auto;mso-padding-alt:10px 25px;background:#1d52ce;" valign="middle">
                                <a href="{{PLATFORM_LINK}}" style="display:inline-block;background:#1d52ce;color:#ffffff;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:3px;" target="_blank">[[INPUT_GO_TO_PLATFORM_BUTTON_TEXT]]</a>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><![endif]-->
    </div>

    <!-- %%SIGNATURE%% -->
  </body>
  
  </html>`,
  inputs: {
    INPUT_BANNER_IMAGE: {
      label: 'Banner Image',
      type: 'FILE',
      options: {
        showPreview: true,
        type: 'IMAGE',
        defaultValue: null
      }
    },
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi {{FIRST_NAME}},</p><p>Please find the current status of the leaderboard below.</p>',
      type: 'HTML'
    },
    INPUT_GO_TO_PLATFORM_BUTTON_TEXT: {
      label: 'Go to platform button text',
      placeholder: 'Go to platform',
      defaultValue: 'Go to platform',
      type: 'STRING'
    },
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/emails/gamification.js